import { useEffect, useState } from "react";

import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { List, X } from "react-bootstrap-icons";

import Navbar from "./navbar";

function Header() {
    const [show, setShow] = useState(false);
    const router = useRouter();

    const [background, setBackground] = useState(true);

    useEffect(() => {
        const listenScrollEvent = () => {
            if (window.scrollY < 80) {
                return setBackground(true);
            } else if (window.scrollY > 80) {
                return setBackground(false);
            }
        };
        if (router.pathname === "/") {
            window.addEventListener("scroll", listenScrollEvent);
            return () =>
                window.removeEventListener("scroll", listenScrollEvent);
        }
    }, [router.pathname]);

    return (
        <header
            className={`app-header ${background && router.pathname === "/" ? "bgGradient" : ""}`}>
            <div className="logo" >
                <Link href="/">
                    {/* <img src="/images/TGI-logo-2021.png" alt="logo_image" /> */}
                    <Image
                        src="/images/TGI-logo-2021.png"
                        alt="logo_image"
                        width={131}
                        height={59}
                        loading="lazy"
                    />
                </Link>
            </div >

            <div className="rightNavigationWrap">
                <div className={`headerTabsNavigation ${show ? "active" : ""}`}>
                    <Navbar />
                </div>
            </div>

            <button className='menuBtn' aria-label="menu" onClick={() => setShow(!show)}>
                {!show ? <List /> : <X color='#FD7278' size="40" />}
            </button>
        </header>
    );
}

export default Header;
